import { LoaderFunctionArgs, redirect } from "react-router"
import { WalletState } from "../../domain/ethereum/Models/WalletState"

export async function loader({ request }: LoaderFunctionArgs) {
  const { searchParams } = new URL(request.url)
  const redirectTo = searchParams.get("redirectTo")

  const wallet = await window.domain.ReconnectEthereumUseCase.execute()
  if (wallet.status === WalletState.STATUS.CONNECTED) {
    if (redirectTo) {
      searchParams.delete("redirectTo")
      return redirect(`${redirectTo}?${searchParams.toString()}`)
    }
    return redirect("/")
  }

  return null
}
